import { useGetProcessingJobs } from "features/dt-plus-setup/api/processingJobs";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { TRANSIENT_RESPONSE_ALGORITHM } from "../model/constants";

export const useTransientProcessingJobs = () => {
  const { projectId } = useParams();
  const query = useGetProcessingJobs(projectId, Boolean(projectId));
  const jobs = useMemo(
    () =>
      (query.data ?? []).filter(
        (job) => job.algorithm?.toLowerCase() === TRANSIENT_RESPONSE_ALGORITHM.toLowerCase()
      ),
    [query.data]
  );

  return { ...query, jobs, projectId };
};
